import { render, staticRenderFns } from "./PbcMessage.vue?vue&type=template&id=3c2f35e0&"
import script from "./PbcMessage.vue?vue&type=script&lang=js&"
export * from "./PbcMessage.vue?vue&type=script&lang=js&"
import style0 from "./PbcMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports